import { Body, Flex, Infobox } from '@cognite/cogs.js-v10';
import { ProgressBar } from '@infield/features/ui/progress-bar';

import * as S from './elements';

interface Props {
  title: string;
  subtitle: string;
  progressPercent: number;
}

/**
 * SchedulesProgressHeader component displays a progress bar with a title, subtitle, and progress percentage.
 *
 * @param {string} title - The title text above the progress bar.
 * @param {string} subtitle - The subtitle text below the progress bar.
 * @param {number} progressPercent - The current progress percentage (0-100).
 * @returns {JSX.Element} The rendered component.
 */
export const SchedulesProgressHeader = ({
  title,
  subtitle,
  progressPercent,
}: Props) => {
  return (
    <S.ProgressBarContainer data-testid="schedules-progress-header">
      <Infobox status="neutral" icon={false} compact>
        <Body size="medium">{title}</Body>
        <ProgressBar progress={progressPercent} rounded />
        <Flex
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Body textColor="muted" size="x-small">
            {subtitle}
          </Body>
          <Body textColor="muted" size="x-small">
            {progressPercent}%
          </Body>
        </Flex>
      </Infobox>
    </S.ProgressBarContainer>
  );
};
